module.exports = __webpack_public_path__ + "static/media/antano-choclo-maiz-y-queso-320g-800x800.e6acd7ae.webp";